@if (insurance && showInsurance) {
    <div class="box box-cart insurance">
        <div class="has-text-left" [formGroup]="insuranceForm">
            <p class="title is-level-5">
                {{ insuranceCmsData.title }}
            </p>
            <div class="columns has-text-left">
                <div class="column is-9">
                    <div class="">
                        <div class="radio-tile is-horizontal">
                            <input
                                checkoutCy="insurance_yes"
                                type="radio"
                                formControlName="choice"
                                [value]="true"
                                id="insuranceCheckedYes"
                                name="choice"
                                required
                            />
                            <label class="radio-label" for="insuranceCheckedYes">
                                <span class="is-fullwidth">
                                    <span class="radio-title">
                                        <div class="columns is-multiline is-aligned-center mb-1">
                                            <div class="column">
                                                <span class="text is-level-2 is-marginless">Avec assurance mobile</span>
                                                <span class="text is-level-2 is-marginless">
                                                    <trg-price
                                                        [price]="insurance?.prices.final"
                                                        [isInlined]="true"
                                                        [size]="'text is-level-2 is-marginless ml-1'"
                                                        [hasPeriod]="true"
                                                    />
                                                </span>
                                            </div>
                                            <div class="column is-narrow">
                                                <div class="sticker is-main">
                                                    <span
                                                        class="text is-level-3 has-text-white has-text-weight-bold is-marginless"
                                                    >
                                                        {{ insuranceCmsData.badge }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                    <span class="radio-description">
                                        <div class="divider"></div>
                                        <!-- Loop over nuggets directus when ready -->
                                        <p class="text is-level-2">
                                            {{ insuranceCmsData.nuggets?.title }}
                                        </p>
                                        <ul class="icon-list mb-1">
                                            @for (item of insuranceCmsData.nuggets?.data; track item) {
                                                <li class="is-flex is-aligned-center">
                                                    @if (item.value) {
                                                        <span class="icon is-small is-success">
                                                            <i class="tri-check icon-colorless" aria-hidden="true"></i>
                                                        </span>
                                                    } @else {
                                                        <span class="icon is-small is-error">
                                                            <i class="tri-times icon-colorless" aria-hidden="true"></i>
                                                        </span>
                                                    }
                                                    <span class="text is-level-2 is-marginless">
                                                        {{ item.label | capitalizeFirstLetter }}
                                                    </span>
                                                </li>
                                            }
                                        </ul>
                                        <p class="text is-level-2">
                                            {{ insuranceCmsData.nuggets?.subtitle }}
                                        </p>
                                        @if (isRenewal) {
                                            <div class="alert is-info">
                                                <div class="icon">
                                                    <i class="tri-infos-circle" aria-hidden="true"></i>
                                                </div>
                                                <div class="body">
                                                    <p class="text is-level-1"><strong></strong></p>
                                                    <p
                                                        class="text is-level-2"
                                                        [innerHTML]="insuranceCmsData.renewLabel | trustHtml"
                                                    ></p>
                                                </div>
                                            </div>
                                        }
                                        @if (showLegals) {
                                            <p class="text has-text-justified insurance-legals">
                                                <span>
                                                    Vous souhaitez adhérer à l'assurance mobile Bouygues Telecom pour
                                                    garantir votre téléphone mobile. La cotisation d'assurance sera
                                                    prélevée mensuellement directement par SPB, courtier gestionnaire de
                                                    l'offre, sur votre compte bancaire. Un contrat d'assurance mobile
                                                    vous engage 12 mois, et vous pouvez résilier votre contrat à tout
                                                    moment à l'issue de la 1ère année. Si vous changez d'avis, vous
                                                    aurez la possibilité de renoncer à votre adhésion pendant un délai
                                                    de 30 jours calendaires à compter de votre date d'adhésion. Avant
                                                    d'adhérer, vous devez consulter la brochure "
                                                </span>
                                                <span>
                                                    <a
                                                        class="link"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        [href]="knowMoreUrl"
                                                    >
                                                        Assurance mobile
                                                    </a>
                                                </span>
                                                <span>
                                                    ". Une fois validée, vous recevrez un mail de la part de SPB
                                                    confirmant votre adhésion, vous adressant l'ensemble des documents
                                                    contractuels et vous invitant à vous connecter à votre espace assuré
                                                    SPB.
                                                </span>
                                            </p>
                                        }
                                    </span>
                                </span>
                            </label>
                        </div>
                        <div class="radio-tile is-horizontal">
                            <input
                                checkoutCy="insurance_no"
                                type="radio"
                                formControlName="choice"
                                [value]="false"
                                id="insuranceCheckedNo"
                                name="choice"
                                required
                            />
                            <label class="radio-label" for="insuranceCheckedNo">
                                <span>
                                    <span class="radio-title">
                                        <span class="text is-level-2 is-marginless">Sans assurance mobile</span>
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="column is-hidden-mobile">
                    <img class="has-radius" src="{{ insuranceCmsData.img }}" alt="" />
                </div>
            </div>
        </div>
    </div>
}
